import { gsap } from 'gsap';

import { CreateThumbnail } from './CreateThumbnail';
import { ElementsManager } from './ElementsManager';

export class MediaLibrary {
  private mediaContainer: HTMLElement | null;
  elementsManager: ElementsManager = new ElementsManager();

  constructor(_mediaContainer: HTMLElement) {
    this.mediaContainer = _mediaContainer;
    this.addEvents();
  }
  private animateThumbnails(): void {
    if (this.mediaContainer) {
      // Convert HTMLCollection to an array and select the image inside each child
      const images = Array.from(this.mediaContainer.children).map((child) =>
        child.querySelector('img')
      );

      // Filter out any null values (in case some children don't have images)
      const validImages = images.filter(Boolean) as HTMLElement[];

      if (validImages.length > 0) {
        gsap.from(validImages, {
          delay: 0.2,
          opacity: 0,
          // yPercent: -100,
          transformOrigin: 'center center',
          scale: 1.2,
          duration: 0.3,
          stagger: 0.1,
          ease: 'power3.out',
        });
      }
    }
  }

  public clearContainer(): void {
    let uploadButtonMediaLibrary: HTMLElement | null | undefined;

    if (this.elementsManager.elements) {
      uploadButtonMediaLibrary = this.elementsManager.elements.uploadButtonMediaLibrary;
    }

    if (this.mediaContainer) {
      const elements = Array.from(this.mediaContainer.children);
      for (const element of elements) {
        if (element !== uploadButtonMediaLibrary) {
          this.mediaContainer.removeChild(element);
        }
      }
    }
  }

  public init(_data?: Array<any>): void {
    this.clearContainer();
    if (_data) {
      this.addThumbnails(_data);
    }
  }

  public addThumbnail(data: Array<any>): void {
    this.addThumbnails(data);
  }

  private addThumbnails(_data: Array<any>): void {
    this.sortData(_data).forEach((thumbnail) => {
      const newThumbnail = this.createThumbnail(thumbnail);
      this.mediaContainer?.appendChild(newThumbnail);
    });
    this.animateThumbnails();
  }

  private createThumbnail(thumbnail: {
    id: string;
    imageURL: string;
    thumbnail: string;
    s3Link: string;
    videoURL: string;
    imageID: string;
  }): HTMLElement {
    const thumbnailCreator = new CreateThumbnail();

    return thumbnailCreator.generateThumbnail(
      thumbnail.id,
      thumbnail.imageURL,
      thumbnail.thumbnail,
      {
        key: 's3-url',
        value: thumbnail.s3Link,
      },
      {
        key: 'video-url',
        value: thumbnail.videoURL,
      },
      {
        key: 'image-url',
        value: thumbnail.imageURL,
      },
      {
        key: 'image-id',
        value: thumbnail.imageID,
      },
      {
        key: 'thumbnail',
        value: thumbnail.thumbnail,
      }
    );
  }
  public setHighlighted(id: string): void {
    // 1. Find the thumbnail with the specific ID
    const thumbnailToHighlight = this.mediaContainer?.querySelector(
      `.cc-thumbnail[data-id="${id}"]`
    );
    console.log('setHighlighted', id);
    console.log('thumbnailToHighlight', thumbnailToHighlight);

    // 2. If the thumbnail exists, dispatch a click event on it
    if (thumbnailToHighlight) {
      thumbnailToHighlight.dispatchEvent(new Event('click', { bubbles: true }));
    }
  }

  private sortData(_data: Array<any>): Array<any> {
    return _data.sort((a, b) => b.id - a.id);
  }

  private addEvents(): void {
    this.mediaContainer?.addEventListener('click', (e) => {
      const clickedElement = e.target as HTMLElement;

      const thumbnailElement = clickedElement.closest('.cc-thumbnail');

      if (thumbnailElement) {
        const target = thumbnailElement as HTMLImageElement;

        const event = new CustomEvent('mediaItemSelected', {
          detail: {
            videoURL: target.getAttribute('data-video-url'),
            imageURL: target.getAttribute('data-image-url'),
            s3Link: target.getAttribute('data-s3-url'),
            id: target.getAttribute('data-id'),
            thumbnail: target.getAttribute('data-thumbnail'),
          },
        });
        document.dispatchEvent(event);
        const event2 = new CustomEvent('imageUrlChanged', {
          detail: { imageUrl: target.getAttribute('data-s3-url') },
        });
        document.dispatchEvent(event2);
        return; // Return after handling the event to avoid checking for other conditions
      }

      const deleteElement = clickedElement.closest('.cc-thumbnail_delete');
      if (deleteElement) {
        const target = deleteElement as HTMLElement;
        const deleteEvent = new CustomEvent('deleteMediaItem', {
          detail: {
            id: target.getAttribute('data-id'),
            videoURL: target.getAttribute('data-video-url'),
          },
        });
        document.dispatchEvent(deleteEvent);
      }
    });
  }
}
